import React from "react";

interface CustomRadioGroupProps<T> {
  name: string;
  options: T[];
  selected: T | undefined;
  onChange: (value: T) => void;
  getLabel: (item: T) => string;
  getValue: (item: T) => string | number;
}

function CustomRadioGroup<T>({
  name,
  options,
  selected,
  onChange,
  getLabel,
  getValue,
}: CustomRadioGroupProps<T>) {
  const selectedValue = selected ? getValue(selected) : null;

  return (
    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
      {options.map((option) => {
        const value = getValue(option);
        const isChecked = value === selectedValue;

        return (
          <label
            key={value}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 12px",
              borderRadius: "12px",
              border:"1px solid #e0e0e0",
              backgroundColor: "#ffffff",
              cursor: "pointer",
              minWidth: "120px",
              transition: "all 0.2s ease",
              fontSize: "16px",
              fontWeight: 500,
              color: "#333333",
            }}
          >
            <input
              type="radio"
              name={name}
              value={value}
              checked={isChecked}
              onChange={() => onChange(option)}
              style={{ display: "none" }}
            />
            <span
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "50%",
                border: "2px solid #3DB6A1",
                backgroundColor: isChecked ? "#3DB6A1" : "#ffffff",
                marginRight: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {isChecked && (
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                  }}
                />
              )}
            </span>
            {getLabel(option)}
          </label>
        );
      })}
    </div>
  );
}

export default CustomRadioGroup;
